import { css } from 'styled-system/css';
import { AgentLayer } from './AgentLayer';
import { AGENTS } from './agents';
import { GRID_DEPTH, GRID_WIDTH, SHEET_RADIUS } from './isometric';
import { SheetLayer } from './SheetLayer';

export function IsometricScene() {
  return (
    <div
      aria-hidden="true"
      className={css({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: { base: '280px', md: '420px' },
        marginTop: '6',
      })}
    >
      <svg
        viewBox="-210 -150 520 380"
        width="100%"
        height="100%"
        className={css({
          overflow: 'visible',
          pointerEvents: 'none',
          '& text': {
            fontFamily: 'mono',
            fontWeight: 'medium',
            letterSpacing: 'wide',
          },
        })}
      >
        <defs>
          <clipPath id="iso-sheet">
            <rect
              width={GRID_WIDTH}
              height={GRID_DEPTH}
              rx={SHEET_RADIUS}
              ry={SHEET_RADIUS}
            />
          </clipPath>
        </defs>
        <g
          className={css({
            fill: 'bg.page',
            stroke: 'text.faint',
            strokeWidth: '1',
            strokeLinejoin: 'round',
            strokeLinecap: 'round',
            '& path, & line, & rect, & polyline': {
              vectorEffect: 'non-scaling-stroke',
            },
          })}
        >
          <SheetLayer />
          {AGENTS.map((agent) => (
            <AgentLayer key={agent.name} agent={agent} />
          ))}
        </g>
      </svg>
    </div>
  );
}
